import { classNames } from '@dimjs/utils';
import { ReactElement } from 'react';
import { CommonProps, withNativeProps } from '../utils/native-props';
import './style.less';

export type Timeline2ItemProps = {
  hideIcon?: boolean;
  left?: {
    label?: string | ReactElement;
    desc?: string | ReactElement;
  };
  right: {
    label?: string | ReactElement;
    desc?: string | ReactElement;
  };
} & CommonProps;

export const Timeline2Item = (props: Timeline2ItemProps) => {
  return withNativeProps(
    props,
    <div className={classNames('v-timeline2-item', { 'v-timeline2-item-hide-icon': props.hideIcon })}>
      <div className="v-timeline2-item-left">
        {props.left?.label ? <div className="v-timeline2-item-label">{props.left?.label}</div> : null}
        <div className="v-timeline2-item-desc">{props.left?.desc}</div>
      </div>
      <div className="v-timeline2-item-icon-wrapper">
        <div className="v-timeline2-item-icon"></div>
      </div>
      <div className="v-timeline2-item-right">
        {props.right?.label ? <div className="v-timeline2-item-label">{props.right?.label}</div> : null}
        <div className="v-timeline2-item-desc">{props.right?.desc}</div>
      </div>
      <div className="v-timeline2-item-line"></div>
    </div>,
  );
};
